/**
 * ScreenHeader — sticky screen header (§5). eyebrow + title (text-lg font-semibold) + subtitle,
 * with an optional right-side slot for actions/filters.
 */
import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface ScreenHeaderProps {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  right?: ReactNode;
  className?: string;
}

export function ScreenHeader({
  eyebrow,
  title,
  subtitle,
  right,
  className,
}: ScreenHeaderProps) {
  return (
    <header
      className={cn(
        "sticky top-0 z-20 -mx-4 mb-4 border-b border-border bg-canvas/85 px-4 py-4 backdrop-blur-md",
        className,
      )}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          {eyebrow ? <div className="eyebrow mb-1">{eyebrow}</div> : null}
          <h1 className="truncate text-lg font-semibold text-ink">{title}</h1>
          {subtitle ? (
            <p className="mt-0.5 text-sm text-muted">{subtitle}</p>
          ) : null}
        </div>
        {right ? <div className="shrink-0">{right}</div> : null}
      </div>
    </header>
  );
}
